import React, { useState } from "react";
import { Tooltip, Typography } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import {
  formatCurrency,
  formatFullName,
  formatNumber,
} from "../../../../lib/utils";
import AssignedVenueModal from "./AssignedVenueModal";
import CapacityOverrideModal from "./CapacityOverrideModal";
import ShluchimTableActions from "./ShluchimTableActions";
import { Link } from "react-router";
import { getShluchimTableColumns } from "../tripHelpers";

function ShluchimTableRecord(props) {
  const {
    defaultChabadHouseCapacity,
    enrolledView,
    hasVenues,
    isTravelTrip,
    readOnlyAccess,
    reloadTableData,
    selected,
    selectionDisabledReason,
    venues,
    shliachEnrollment: {
      assignedVenueID,
      assignedVenueName,
      preferredVenueName,
      campusName,
      capacityOverride,
      chabadHouseID,
      chabadHouseName,
      chabadHouseOwes,
      id: enrollmentId,
      isShliachAttending,
      isShluchaAttending,
      numberOfChaperones,
      numberOfShluchim,
      cociOwes,
      numOfStudentRegistered,
      shliachID,
      shliachFirstName,
      shliachLastName,
      shluchaID,
      shluchaFirstName,
      shluchaLastName,
    },
    showSelectCheckbox,
    toggleSelectShliach,
  } = props;

  const [showCapacityModal, setShowCapacityModal] = useState(false);
  const [showVenueModal, setShowVenueModal] = useState(false);
  const effectiveCapacity = capacityOverride ?? defaultChabadHouseCapacity;

  const columns = getShluchimTableColumns(
    isTravelTrip,
    defaultChabadHouseCapacity,
    false,
    hasVenues,
  );
  const columnSizes = columns.map((column) => column.size).join(" ");

  const venueNameDisplay = assignedVenueName ? (
    assignedVenueName
  ) : preferredVenueName ? (
    <span className="accent-text italic-text">
      Not set, {preferredVenueName} is preferred
    </span>
  ) : (
    "—"
  );

  return (
    <div
      className="trip-shluchim-table-row"
      style={{ gridTemplateColumns: columnSizes }}
    >
      <div className="flex">
        {showSelectCheckbox && (
          <div className="tooltip-container mr-8">
            <div className="flex custom-checkbox-container mr-8">
              <input
                className="custom-checkbox"
                checked={selected}
                disabled={!!selectionDisabledReason}
                id={`enrollment-${chabadHouseID}`}
                onChange={toggleSelectShliach}
                type="checkbox"
              />
              <label
                className="flex-align-center"
                htmlFor={`enrollment-${chabadHouseID}`}
              />
            </div>
            {selectionDisabledReason && (
              <span className="tooltip">{selectionDisabledReason}</span>
            )}
          </div>
        )}
        <Link
          className="link-text-secondary flex flex-align-center"
          to={`/shluchim/${shliachID}`}
        >
          {!isTravelTrip && (
            <Tooltip
              title={
                <Typography fontSize={12}>
                  {isShliachAttending ? "Is attending" : "Is not attending"}
                </Typography>
              }
            >
              <i
                className="material-icons mr-8"
                style={{
                  color: isShliachAttending ? "#228b22" : "#e94746",
                }}
              >
                {isShliachAttending ? "check" : "close"}
              </i>
            </Tooltip>
          )}
          {formatFullName(shliachFirstName, shliachLastName)}
        </Link>
      </div>
      <p>
        <Link
          className="link-text-secondary flex flex-align-center"
          to={`/shluchim/${shluchaID}`}
        >
          {!isTravelTrip && (
            <Tooltip
              title={
                <Typography fontSize={12}>
                  {isShluchaAttending ? "Is attending" : "Is not attending"}
                </Typography>
              }
            >
              <i
                className="material-icons mr-8"
                style={{
                  color: isShluchaAttending ? "#228b22" : "#e94746",
                }}
              >
                {isShluchaAttending ? "check" : "close"}
              </i>
            </Tooltip>
          )}
          {formatFullName(shluchaFirstName, shluchaLastName)}
        </Link>
      </p>
      <p>{chabadHouseName}</p>
      <p>{campusName}</p>
      {!isTravelTrip && (
        <p>
          {enrolledView
            ? `${formatNumber(numberOfShluchim)} + ${formatNumber(
                numberOfChaperones,
              )}`
            : "—"}
        </p>
      )}
      <p>{enrolledView ? formatNumber(numOfStudentRegistered) : "—"}</p>
      {!!defaultChabadHouseCapacity && (
        <p>
          {enrolledView ? (
            readOnlyAccess ? (
              <span>{effectiveCapacity}</span>
            ) : (
              <span
                className="link-text-secondary flex flex-align-center"
                onClick={() => setShowCapacityModal(true)}
                style={{ cursor: "pointer" }}
              >
                {effectiveCapacity}
                <EditIcon
                  fontSize="small"
                  style={{ marginLeft: 4, opacity: 0.6 }}
                />
              </span>
            )
          ) : (
            "—"
          )}
        </p>
      )}
      {!isTravelTrip && hasVenues && (
        <p>
          {enrolledView ? (
            readOnlyAccess ? (
              venueNameDisplay
            ) : (
              <span
                className="link-text-secondary flex flex-align-center"
                onClick={() => setShowVenueModal(true)}
                style={{ cursor: "pointer" }}
              >
                {venueNameDisplay}
                <EditIcon
                  fontSize="small"
                  style={{ marginLeft: 4, opacity: 0.6 }}
                />
              </span>
            )
          ) : (
            "—"
          )}
        </p>
      )}
      {!isTravelTrip && (
        <>
          <p>{enrolledView ? `$${formatCurrency(cociOwes)}` : "—"}</p>
          <p>{enrolledView ? `$${formatCurrency(chabadHouseOwes)}` : "—"}</p>
        </>
      )}
      {enrolledView ? <ShluchimTableActions {...props} /> : <p>—</p>}
      {showVenueModal && (
        <AssignedVenueModal
          onClose={(didUpdate) => {
            setShowVenueModal(false);
            if (didUpdate) {
              reloadTableData();
            }
          }}
          campusName={campusName}
          chabadHouseName={chabadHouseName}
          currentAssignedVenueId={assignedVenueID}
          enrollmentId={enrollmentId}
          preferredVenueName={preferredVenueName}
          shliachFirstName={shliachFirstName}
          shliachLastName={shliachLastName}
          shluchaFirstName={shluchaFirstName}
          shluchaLastName={shluchaLastName}
          venues={venues}
        />
      )}
      {showCapacityModal && (
        <CapacityOverrideModal
          onClose={(didUpdate) => {
            setShowCapacityModal(false);
            if (didUpdate) {
              reloadTableData();
            }
          }}
          campusName={campusName}
          chabadHouseName={chabadHouseName}
          enrollmentId={enrollmentId}
          currentCapacityOverride={capacityOverride}
          defaultChabadHouseCapacity={defaultChabadHouseCapacity}
          shliachFirstName={shliachFirstName}
          shliachLastName={shliachLastName}
          shluchaFirstName={shluchaFirstName}
          shluchaLastName={shluchaLastName}
        />
      )}
    </div>
  );
}
export default React.memo(ShluchimTableRecord);
